import { client } from "../sanity/client";

export const getTips = async () => {

    const query = `
    *[_type == "tip"] | order(_createdAt desc){
        _id,
        _createdAt,
        title,
        category,
        description,
        background,
        content,
        image{
            asset->{
                url
            }
        }
    }
    `;

    return await client.fetch(query);

};